import { useState, useEffect } from "react";

const navItems = [
  { label: "Processing", href: "#processing-options" },
  { label: "Services", href: "#services" },
  { label: "Local Area", href: "#local-area" },
  { label: "Timing", href: "#timing" },
  { label: "Destinations", href: "#destinations" },
  { label: "Facilities", href: "#facilities" },
  { label: "Compare", href: "#compare" },
  { label: "FAQ", href: "#faq" },
  { label: "Resources", href: "#resources" },
];

export default function BentonvilleStickyNav() {
  const [active, setActive] = useState("");
  useEffect(() => {
    const handle = () => {
      const sections = navItems.map((n) => document.querySelector(n.href));
      const scroll = window.scrollY + 120;
      for (let i = sections.length - 1; i >= 0; i--) {
        const s = sections[i];
        if (s && s.getBoundingClientRect().top + window.scrollY <= scroll) { setActive(navItems[i].href); return; }
      }
      setActive("");
    };
    window.addEventListener("scroll", handle);
    return () => window.removeEventListener("scroll", handle);
  }, []);
  return (
    <div className="sticky top-[70px] z-40 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-1 overflow-x-auto py-2">
          {navItems.map((item) => (<a key={item.href} href={item.href} className={`whitespace-nowrap px-3 py-1.5 rounded-full text-xs font-semibold transition-all ${active === item.href ? "bg-[#1A365D] text-white" : "text-gray-600 hover:bg-gray-100"}`}>{item.label}</a>))}
        </div>
      </div>
    </div>
  );
}